<template>

<div class="item" :class="{'is-admin': isAdmin}">

    <div class="item-head" :class="{'is-disabled': !item.enabled && !isAdmin}">

        <app-icon v-if="!item.enabled && !isPreview" icon="show" v-tooltip="'Hidden'" class="item-lock is-grey" />
        <app-icon v-if="item.locked === 2 && item.enabled" icon="unlock" v-tooltip="'Locked'" class="item-lock" />
        <app-icon v-if="item.locked === 1 && item.enabled" icon="unlock" v-tooltip="'Edit only'" class="item-lock is-yellow" />
    
        <div class="item-head-name">
        
            {{ item.name }}
            <small v-if="item.description">{{ item.description }}</small>
            
        </div>

        <div class="item-head-actions">

            <div class="item-head-actions-item is-green" v-if="!isAdmin && item.locked < 2 && item.enabled" v-tooltip="'Currently showing<small>Click to hide</small>'" v-on:click="$emit('hide', item)"><app-icon icon="hide" /></div>
            <div class="item-head-actions-item is-grey" v-if="!isAdmin && item.locked < 2 && !item.enabled" v-tooltip="'Currently hidden<small>Click to show</small>'" v-on:click="$emit('show', item)"><app-icon icon="show" /></div>
            <div class="item-head-actions-item" v-tooltip="'Move section up'" v-if="!isFirst && isAdmin" v-on:click="$emit('up', item)"><app-icon icon="move.up" /></div>
            <div class="item-head-actions-item" v-tooltip="'Move section down'" v-if="!isLast && isAdmin" v-on:click="$emit('down', item)"><app-icon icon="move.down" /></div>
            <div class="item-head-actions-item" v-if="isAdmin" v-tooltip="'Edit section details'" v-on:click="$emit('edit', item)"><app-icon icon="settings" /></div>
            <div class="item-head-actions-item" v-if="isAdmin || (item.locked < 2 && item.types.length)" v-tooltip="'Add block to section'" v-on:click="onAddClick"><app-icon icon="add" /></div>
            <div class="item-head-actions-item" v-if="isAdmin || !item.locked" v-tooltip="'Remove section'" v-on:click="$emit('remove', item)"><app-icon icon="remove" /></div>

        </div>

    </div>

    <div class="item-blocks" :class="{'is-empty': isEmpty}" v-if="item.enabled || isAdmin">

        <transition-group name="flip-list">

        <template v-for="(text, index) in item.blocks">

            <app-blocks 
                :key="text.id" 
                :index="index" 
                :is-first="index === 0" 
                :is-last="index === item.blocks.length - 1" 
                :item="text" 
                :is-admin="isAdmin" 
                v-on:click="onBlockClick" 
                v-on:show="onBlockShow" 
                v-on:hide="onBlockHide" 
                v-on:up="onBlockUp" 
                v-on:down="onBlockDown" 
                v-on:remove="onBlockRemove" 
            />

        </template>

        </transition-group>

        <div class="item-blocks-empty" v-if="isEmpty" v-on:click="onEmptyClick">Click to add block</div>

    </div>

    <com-block v-if="is.block" :section="item" :item="is.block" :is-admin="isAdmin" v-on:close="onBlockClose" v-on:confirm="onBlockConfirm" />

</div>

</template>

<script>

import comBlock from './Block'

export default {

    props: ['item', 'isFirst', 'isLast', 'isAdmin'],

    components: {
        'com-block': comBlock
    },

    data: function() {

        return {
            is: {
                block: false
            },
            insertPoint: false
        }

    },

    computed: {

        isEmpty: function() {

            return !this.item.blocks.length

        }

    },

    methods: {

        onEmptyClick: function() {

            this.is.block = true
            this.insertPoint = false

        },

        onAddClick: function() {

            this.is.block = true
            this.insertPoint = this.item.blocks.length

        },

        onBlockClose: function() {

            this.is.block = false

        },

        onBlockClick: function(value) {

            this.$vueset(this.is, 'block', value)

        },

        onBlockUp: function(value) {

            var item = this.$util.clone(this.item)

            this.$util.collection.up(item.blocks, value)

            this.$emit('input', item)

        },

        onBlockShow: function(value) {

            var item = this.$util.clone(this.item)

            value.enabled = 1

            this.$util.collection.update(item.blocks, value)

            this.$emit('input', item)

        },

        onBlockHide: function(value) {

            var item = this.$util.clone(this.item)

            value.enabled = 0

            this.$util.collection.update(item.blocks, value)

            this.$emit('input', item)

        },

        onBlockDown: function(value) {

            var item = this.$util.clone(this.item)

            this.$util.collection.down(item.blocks, value)

            this.$emit('input', item)

        },

        onBlockRemove: function(value) {

            var item = this.$util.clone(this.item)

            this.$util.collection.remove(item.blocks, value)

            this.$emit('input', item)

        },

        onBlockConfirm: function(value) {

            var item = this.$util.clone(this.item)

            if(!value.id) {
                
                value.id = this.$util.generateKey(16)

                this.$util.collection.add(item.blocks, value, this.insertPoint)

            } else {

                this.$util.collection.update(item.blocks, value)

            }

            this.$emit('input', item)

            this.is.block = false

        }

    }

}

</script>

<style scoped>

.flip-list-move {
    transition: transform 100ms linear;
}

.item {
    display: grid;
    border: 2px solid #eee;
    border-radius: 10px;
}

.item:not(.is-admin) {
    margin: 10px 0px;
}

.item:not(.is-admin):first-child {
    margin-top: 0px;
}

.item:not(.is-admin):last-child {
    margin-bottom: 0px;
}

.item-head {
    color: #0b234e;
    flex-shrink: 0;
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 10px;
    align-items: center;
    padding: 10px 10px 10px 20px;
    border-bottom: 1px solid #eee;
}

.item-head.is-disabled {
    border-bottom: 0px;
}

.item-head-name {
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
}

.item-head-name small {
    display: block;
    font-size: 12px;
    line-height: 14px;
    font-weight: 300;
}

.item-head-actions {
    display: flex;
}

.item-head-actions-item {
    border: 2px solid #eee;
    text-align: center;
    line-height: 38px;
    height: 40px;
    width: 40px;
    font-size: 16px;
    cursor: pointer;
    margin-left: -2px;
    color: #343434;
}

.item-head-actions-item:first-child {
    margin-left: 0px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

.item-head-actions-item:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

.item-head-actions-item.is-grey {
    border-color: #666;
    color: #666;
    z-index: 2;
}

.item-head-actions-item.is-green {
    border-color: #90c48b;
    color: #90c48b;
    z-index: 2;
}

.item-head-actions-item.is-red {
    border-color: #f75858;
    color: #f75858;
    z-index: 2;
}

.item-head-actions-item:hover {
	color: #fff;
	background-color: #4082d3;
    z-index: 3;
	border-color: #4082d3;
}

.item-blocks.is-empty {
    min-height: 120px;
}

.item-blocks-empty {
	text-align: center;
	line-height: 116px;
	color: #999;
	font-size: 16px;
	cursor: pointer;
	font-weight: 500;
}

.item-blocks.is-empty:hover {
	border-color: #4082d3;
}

.item-blocks.is-empty:hover .item-blocks-empty {
	color: #4082d3;
}

.item-lock {
	position: absolute;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background-color: #fff;
	border: 2px solid #eee;
	text-align: center;
	line-height: 22px;
	left: -12px;
	font-size: 12px;
	top: 50%;
	margin-top: -12px;
    border-color: #f75858;
    color: #f75858;
}

.item-lock.is-yellow {
    border-color: #f8d205;
    color: #f8d205;
}

.item-lock.is-grey {
    border-color: #666;
    color: #666;
}

</style>